// extracted by mini-css-extract-plugin
module.exports = {"uploaded":"UploadedStorageFiles_uploaded__3Etl3"};